import Styled from 'styled-components';

const AuthWrapper = Styled.div`
  background-color: ${({ theme }) => theme['white-color']};
  height:100vh;
  .auth-password-change {
    display: block !important;
}
.grid-item-wrapper.mt-4 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
}
  .auth-container-overlay-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  .auth-container {
    max-width: 500px;
    width: 100%;
    background: #fff;
    margin: auto;
    /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px; */
    padding: 24px;
    border-radius: 8px;
}
  }
  .conatiner{
    max-width:1800px;
    margin: 0 auto;
    height:100vh;
    overFlow:auto;
  }
  span{
    font-size: ${({ theme }) => theme['font-size-base']};
      color: ${({ theme }) => theme['lynch-color']};
  }
  .password-input{
   position: relative;
   svg{
     position: absolute;
     top: 31px;
    right: 11px;
    cursor: pointer;
    user-select:none;
    color: ${({ theme }) => theme['primary-color']};
   }
  }
  .bg-albaster{
    background-color:${({ theme }) => theme['alabaster-color']}80 ;
    height:100%;
    display:flex;
    align-items:center;
    justify-content:center;
  }
  .url-link{
    font-size: ${({ theme }) => theme['font-size-base']};
      color: ${({ theme }) => theme['primary-color']};
      text-decoration:underline;
  }
  .handle-recaptcha{
    transform:scale(0.88);
    -webkit-transform:scale(1.18);
    transform-origin:0 0;
    -webkit-transform-origin:0 0; 
   } 
  `;
const InfoVideoWrapper = Styled.div`
  padding-left:40px;
  padding-top:97px;
  h2{
      color: ${({ theme }) => theme['secondary-color']};
  }
  .onBorading-innerVideo{
    height: 500px;
    width: 100%;
}
  }

  `;


export { AuthWrapper, InfoVideoWrapper };
